<template>
    <div class="ini-comment-control">
        <div class="ini-comment-control__input" :class="{'ini-comment-control__input--active': inputActive}">
            <textarea ref="input" class="textarea-autosize" :value="value" :placeholder="placeholder"
                      @input="updateSendButtonStatus" @keydown.ctrl.enter="sendButtonClicked(value)" @keydown.meta.enter="sendButtonClicked(value)">
            </textarea>
            <ini-drop-zone ref="dropzone" @changed="updateSendButtonStatus" @validationCompleted="onValidationCompleted($event)"></ini-drop-zone>
        </div>
        <ini-button class="ini-comment-control__button" :disabled="sendButtonDisabled"
                    @click.native="sendButtonClicked(value)">
            {{ $t('LBL_SEND_COMMENT') }}
        </ini-button>
    </div>
</template>

<script>
    import IniButton from '@/components/Button'
    import autosize from 'autosize'
    import IniDropZone from '@/components/form_elements/DropZone'

    export default {
        data() {
            return {
                value: null,
                sendButtonDisabled: true,
                inputActive: false,
                placeholder: this.$t('LBL_HELPDESK_SEND_MESSAGE'),
                hasValidationErrorOnAttachments: false
            }
        },

        props: {
            focus: Boolean,
            message: String,
        },

        components: {
            IniButton,
            IniDropZone,
        },

        computed: {
            element() {
                return $('textarea', this.$el)
            }
        },

        methods: {
            updateSendButtonStatus(event) {
                if(this.hasValidationErrorOnAttachments) {
                    this.deactivate()
                    return
                }

                this.value = this.$refs.input.value

                if(!this.value && this.getAttachments().length > 0){
                    this.activate(true)
                    return
                }

                if(this.value){
                    this.activate()
                } else{
                    this.deactivate()
                }
            },

            onValidationCompleted(validationFailed) {
                this.hasValidationErrorOnAttachments = validationFailed
                this.updateSendButtonStatus()
            },

            activate(skipInputActivate) {
                this.sendButtonDisabled = false

                if(!skipInputActivate){
                    this.inputActive = true
                }
            },

            deactivate() {
                this.sendButtonDisabled = true
                this.inputActive = false
            },

            sendButtonClicked(message) {
                if(!message && this.getAttachments().length === 0){
                    return
                }

                this.$emit('send-button-clicked', message);
            },

            getAttachments() {
              return this.$refs.dropzone.getFiles()
            },

            clear() {
                this.value = null
                this.element.val('')
                this.$refs.dropzone.clear()
                this.$refs.input.focus()
                // Reset autosize
                $(this.$refs.input).css({'height' : ''});
            }
        },

        mounted() {
            this.value = this.message
            if(this.value){
                this.activate()
            }
            autosize(this.element);
            if(this.focus){
                this.$refs.input.focus()
            }
        },

        destroyed() {
            autosize.destroy(this.element)
        }
    }
</script><style lang="scss">@import "@/assets/scss/components/HelpDesk/Comment/_commentcontrol.scss";</style>